import { render, staticRenderFns } from "./CidadaosVinculadosChart.vue?vue&type=template&id=9767c9f0"
import script from "./CidadaosVinculadosChart.vue?vue&type=script&lang=js"
export * from "./CidadaosVinculadosChart.vue?vue&type=script&lang=js"
import style0 from "./CidadaosVinculadosChart.vue?vue&type=style&index=0&id=9767c9f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports